<script setup>
const props = defineProps({
  mapCenter: { type: Array, required: true },
  mapZoom: { type: Number, required: true },
  tmpMarkerPosition: { type: Object, required: true },
  areaEn: { type: String, default: '' },
  prefEn: { type: String, default: '' },
  cityCode: { type: String, default: '' }
})
const route = useRoute()
const config = useRuntimeConfig()
const isOverlayOpen = defineModel('isOverlayOpen', { type: Boolean })
const position = useCookie('mapView')
const markerPosition = useCookie('markerPosition', { default: () => null })
const { data: buttonList } = await useFetch('/api/radar/buttonList')

const onClickButton = (weather) => {
  if (weather === 'kosa') {
    isOverlayOpen.value = false
    return
  } else {
    position.value = { lat: props.mapCenter[1], lon: props.mapCenter[0], zoom: props.mapZoom }
    if (Object.keys(props.tmpMarkerPosition).length > 0) {
      markerPosition.value = props.tmpMarkerPosition
    }
    const path = createRadarLink(weather, route.path)
    return navigateTo(`${config.public.hostDomain}${path}`, { external: true })
  }
}
const permanentButtonList = [
  {
    category: 'tenki',
    text: '天気',
    link: generateWxLink(props.areaEn, props.prefEn, props.cityCode),
    icon: 'https://gvs.weathernews.jp/onebox/img/icon/list-menu_icon_forecast.svg'
  },
  {
    category: 'typhoon',
    text: '台風',
    link: 'https://weathernews.jp/onebox/typhoon/?fm=radar_menu',
    icon: 'https://gvs.weathernews.jp/onebox/img/icon/list-menu_icon_typhoon.svg'
  }
]
</script>

<template>
  <MiOOverlay
    :data-showed="isOverlayOpen"
    @click.self="isOverlayOpen = false"
  >
    <MiMOverlayBlock
      data-position="right"
      data-style="border"
    >
      <div>
        <MiARadarButton
          v-for="({ category, label }) in buttonList"
          :key="category"
        >
          <KosaRadarLinkButton
            :category="category"
            :label="label"
            @click="onClickButton(category)"
          />
        </MiARadarButton>
      </div>
      <div>
        <MiARadarButton
          v-for="(item, index) in permanentButtonList"
          :key="index"
        >
          <a :href="item.link">
            <span>
              <figure>
                <img
                  :src="item.icon"
                  width="24"
                  height="24"
                  alt=""
                >
              </figure>
            </span>
            <span>{{ item.text }}</span>
          </a>
        </MiARadarButton>
      </div>
      <MiACloseButton data-type="circle">
        <button @click="isOverlayOpen = false" />
      </MiACloseButton>
    </MiMOverlayBlock>
  </MiOOverlay>
</template>

<style lang="scss" scoped>
</style>
